var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-1" }, [
    _c("h3", { staticClass: "primary" }, [
      _vm._v(_vm._s(_vm.__("globals.this_invoice")) + ":"),
    ]),
    _vm._v(" "),
    _c("strong", [_vm._v(_vm._s(_vm.__("globals.purchase_details")))]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex border-top pt-05 pb-05" }, [
      _c("div", [_vm._v(_vm._s(_vm.__("globals.total_cart_price")))]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _vm._v(_vm._s(_vm._f("currency")(_vm.grossTotal, _vm.siteTax))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex border-bottom pb-05" }, [
      _c("div", [
        _vm._v(
          _vm._s(_vm.__("globals.tax")) + " (" + _vm._s(_vm.siteTax.name) + ")"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _vm._v(_vm._s(_vm._f("tax")(_vm.grossTotal, _vm.siteTax))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex border-bottom pt-05 pb-05" }, [
      _c("div", [_vm._v(_vm._s(_vm.__("globals.total_due")) + ":")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _vm._v(_vm._s(_vm._f("currency")(_vm.totalOwing, _vm.siteTax))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-1" }, [
      _vm.is_guest === true
        ? _c("span", [
            _vm.totalOwing === 0 && _vm.cart_item_count > 0
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary form-control",
                    attrs: { href: "/free-charge" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.place_order")))]
                )
              : _vm.cart_item_count > 0
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary form-control",
                    attrs: { href: "cart/checkout" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.place_order")))]
                )
              : _vm._e(),
          ])
        : _c("span", [
            _vm.totalOwing === 0 && _vm.cart_item_count > 0
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary form-control",
                    attrs: { href: "/member/free-charge" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.place_order")))]
                )
              : _vm.cart_item_count > 0
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary form-control",
                    attrs: { href: "/member/cart/checkout" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.place_order")))]
                )
              : _vm._e(),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }